import { render } from "./GuarantorRequests.vue?vue&type=template&id=40226994&scoped=true&bindings={\"id\":\"props\",\"result\":\"data\",\"data\":\"data\",\"userId\":\"data\",\"error\":\"data\",\"isLoading\":\"data\",\"loaderColor\":\"data\",\"disableNext\":\"data\",\"processResponse\":\"options\"}"
import script from "./GuarantorRequests.vue?vue&type=script&lang=js"
export * from "./GuarantorRequests.vue?vue&type=script&lang=js"

import "./GuarantorRequests.vue?vue&type=style&index=0&id=40226994&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40226994"

export default script